module.exports = __webpack_public_path__ + "static/media/updaptLogo.f2276dc9.svg";